module.exports = {
  senpUrl: '/app/income/senp',
  sepUrl: '/app/income/sep',
  salariedUrl: '/app/income/salaried',
  lapPropertyUrl: '/app/LAP/property',
  propertyDetailsURl: '/app/property',
  dashboardURl: '/app/dashboard',
  userKyc: '/app/UserKyc',
  userKycLap: '/app/LAP/kyc',
  redirectToDashboardDisplay: 'GO TO DASHBOARD',
  showSidebarAndHeader: true,
  dontShowSideBarAndHeader: false,
  isLems: true,
};
